import { divWithClassName } from '../../../services/Component';
import styles from './style.m.less';

const blockWithClassName = className => {
    const Component = divWithClassName(className);
    return ({ centered, width }) => (
        <div className={centered ? styles.containerCentered : styles.container}>
            <Component style={width && { width: width + '%' }} />
        </div>
    );
};

export const AvatarLarge = blockWithClassName(styles.avatarLarge);
export const HeadingLine = blockWithClassName(styles.headingLine);
export const SubHeadingLine = blockWithClassName(styles.subHeadingLine);
export const Line = blockWithClassName(styles.line);
export const Space = blockWithClassName(styles.space);
